import { render, staticRenderFns } from "./apiGuides.vue?vue&type=template&id=2de8af50&scoped=true"
import script from "./apiGuides.vue?vue&type=script&lang=js"
export * from "./apiGuides.vue?vue&type=script&lang=js"
import style0 from "./apiGuides.vue?vue&type=style&index=0&id=2de8af50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8af50",
  null
  
)

export default component.exports